export default "__VITE_ASSET__CGTl5UCG__"